import Swiper from "swiper";

export function sliderLinks() {
    $('.links-slider').each(function(){
        var attrs = $(this).data();
        let selector = "#LinksSlider"+attrs['list'];
        var swiper = new Swiper(selector, {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 20,
            scrollbar: {
                el: '.swiper-scrollbar-'+attrs['list'],
                draggable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                991: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1199: {
                    slidesPerView: 4,
                    spaceBetween: 30
                }
            },
            navigation: {
                nextEl: '.links-slider-next-'+attrs['list'],
                prevEl: '.links-slider-prev-'+attrs['list']
            }
        });
    });

}
